import { useEffect, useState } from "react";
import { Button } from "../ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Alert, AlertDescription } from "../ui/alert";
import {  Mail, CheckCircle } from "lucide-react";
import { CompanyLogo } from "../ui/company-logo";
import { apiService } from "../../utils/apiService";

interface ForgotPasswordFormProps {
  onBackToLogin: () => void;
}

export function ForgotPasswordForm({ onBackToLogin }: ForgotPasswordFormProps) {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    
  }, []);

  useEffect(() => {
    
  }, [isSuccess]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      await apiService.requestPasswordReset(email);
      setIsSuccess(true);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Failed to send reset email",
      );
    } finally {
      setIsLoading(false);
    }
  };

  if (isSuccess) {
    return (
      <div className="h-screen overflow-hidden text-slate-100 relative font-sans">
        <div className="h-full flex items-center justify-center px-4 sm:px-6">
          <div
            className="w-[980px] h-[600px] max-w-[95vw] max-h-[90vh] glass-panel rounded-lg overflow-hidden shadow-sm animate-fade-in-up"
            
            
          >
            <div className="grid h-full lg:grid-cols-2">
              <div
                className="relative hidden lg:flex items-center justify-center overflow-hidden bg-slate-900 bg-cover bg-center"
                style={{ backgroundImage: "url('/Image.png')" }}
                
                
              >
                <div className="absolute inset-0  /80 /70 /90"></div>
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(0,0,0,0.08),_transparent_55%)]"></div>
                <div className="relative z-10 flex w-full max-w-md flex-col items-center justify-center px-10 text-center text-white">
                  <CompanyLogo size="xl" showText={false} variant="dark" />
                  <p
                    className="mt-4 text-lg text-slate-200"
                  >
                    Engineering the Future
                  </p>
                </div>
              </div>

              <div className="flex h-full items-center justify-center px-6 py-6 sm:px-10 lg:px-12">
                <Card
                  className="w-full max-w-md border-0 bg-transparent -none"
                >
                <CardHeader
                  className="space-y-2 pb-4 text-center"
                >
                  <div className="flex items-center justify-center">
                    <CompanyLogo size="lg" showText={false} variant="dark" />
                  </div>
                  <div className="space-y-2">
                      <div className="flex items-center justify-center gap-2">
                        <CheckCircle className="h-6 w-6 text-green-600" />
                        <CardTitle className="text-2xl font-semibold text-green-600">
                          Reset Link Sent
                        </CardTitle>
                      </div>
                      <CardDescription className="text-sm text-slate-500 dark:text-slate-400">
                        Check your email for your password reset link
                      </CardDescription>
                    </div>
                  </CardHeader>

                  <CardContent
                    className="space-y-4"
                    
                    
                  >
                    <div className="text-center space-y-2">
                      <p className="text-sm text-muted-foreground">
                        We've sent a reset link to <strong>{email}</strong>
                      </p>
                      <p className="text-sm text-muted-foreground">
                        The link will expire in 30 minutes for security.
                      </p>
                    </div>

                    <div className="text-xs text-muted-foreground text-center">
                      <p>
                        Back to login{" "}
                        <button
                          onClick={onBackToLogin}
                          className="text-gray-700 dark:text-gray-300 hover:underline font-medium"
                        >
                          here
                        </button>
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen overflow-hidden text-slate-100 relative font-sans">
      <div className="h-full flex items-center justify-center px-4 sm:px-6">
        <div
          className="w-[980px] h-[600px] max-w-[95vw] max-h-[90vh] glass-panel rounded-lg overflow-hidden shadow-sm animate-fade-in-up"
          
          
        >
          <div className="grid h-full lg:grid-cols-2">
            <div
              className="relative hidden lg:flex items-center justify-center overflow-hidden bg-slate-900 bg-cover bg-center"
              style={{ backgroundImage: "url('/Image.png')" }}
              
              
            >
              <div className="absolute inset-0  /80 /70 /90"></div>
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(0,0,0,0.08),_transparent_55%)]"></div>
              <div className="relative z-10 flex w-full max-w-md flex-col items-center justify-center px-10 text-center text-white">
                <CompanyLogo size="xl" showText={false} variant="dark" />
                <p
                  className="mt-4 text-lg text-slate-200"
                >
                  Engineering the Future
                </p>
              </div>
            </div>

            <div className="flex h-full items-center justify-center px-6 py-6 sm:px-10 lg:px-12">
              <Card
                className="w-full max-w-md border-0 bg-transparent -none"
              >
                <CardHeader
                  className="space-y-2 pb-4 text-center"
                >
                  <div className="flex items-center justify-center">
                    <CompanyLogo size="lg" showText={false} variant="dark" />
                  </div>
                  <div className="space-y-2">
                    <CardTitle className="text-2xl font-semibold font-display text-white tracking-tight">
                      Recover your account
                    </CardTitle>
                    <CardDescription className="text-sm text-muted-foreground">
                      Enter your email address and we'll send you a password reset
                      link.
                    </CardDescription>
                  </div>
                </CardHeader>

                <CardContent className="space-y-4">
                  <form
                    onSubmit={handleSubmit}
                    className="space-y-4"
                    
                    
                  >
                    <div className="space-y-2">
                      <Label htmlFor="email">Email Address</Label>
                      <Input
                        id="email"
                        type="email"
                        placeholder="Enter your email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="h-12 border-white/10 hover:border-white/20 bg-black/20 text-white placeholder:text-white/40 focus-visible:ring-2 focus-visible:border-primary focus-visible:ring-primary/50 font-sans rounded-xl transition-all"
                      />
                    </div>

                    {error && (
                      <Alert variant="destructive">
                        <AlertDescription>{error}</AlertDescription>
                      </Alert>
                    )}

                    <div className="space-y-3">
                      <Button
                        type="submit"
                        className="w-full h-12 text-[15px] btn-primary-glow text-white font-[600] rounded-xl hover-lift"
                        disabled={isLoading || !email}
                      >
                        {isLoading ? (
                          <>
                            <div className="h-4 w-4 bg-current animate-spin mr-2" />
                            Sending Reset Email...
                          </>
                        ) : (
                          <>
                            <Mail className="h-4 w-4 mr-2" />
                            Send Reset Email
                          </>
                        )}
                      </Button>

                    </div>
                  </form>

                  <div className="text-xs text-muted-foreground text-center">
                    <p>
                      Remembered your password?{" "}
                      <button
                        onClick={onBackToLogin}
                        className="text-gray-700 dark:text-gray-300 hover:underline font-medium"
                      >
                        Back to login
                      </button>
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
